<template>
        <h2 class="name movde  movehed" >
              <strong class="font-50 movsho">SHOW TIMES</strong></h2>
</template>


<script>
export default {
    
}
</script>
